// src/pages/Home.js
import React, { useState, useEffect } from "react";
import "./Pages.css";
import Admin from "../Admin/Admin"; // Admin-Komponente importieren
import { trainingVote } from "../Admin/Api"; // Beispiel, falls die Funktion dort definiert ist
import { TrainingCanceled } from './TrainingCanceled';
import useTrainingStore from "../stores/TrainingStore";
import { BiColorFill } from "react-icons/bi";
import { useNavigate } from 'react-router-dom';
import { auth } from '../Admin/Api.js';


const Home = () => {
  const googleMapsUrl = 'https://www.google.com/maps/place/Freie+Evangelische+Schule+Ulm/@48.3979009,9.9722413,17z/data=!3m1!4b1!4m6!3m5!1s0x4799642f49b3056b:0x1fd9bd21b2a94985!8m2!3d48.3979009!4d9.9722413!16s%2Fg%2F1tplp86b?hl=de&entry=ttu&g_ep=EgoyMDI0MTAyOS4wIKXMDSoASAFQAw%3D%3D'
  const [username, setUsername] = useState(null); // Benutzername
  const [role, setRole] = useState(null); // Rolle des Benutzers
  const adresse = "Turnhalle der freien Evangelischen Schule Ulm";
  const navigate = useNavigate();

  const { anwesend, abwesend, trainingText,
    trainingDeadline, isTrainingCanceled, voteStatus, checkboxOne,
    checkboxTwo, setCheckedOne, setCheckedTwo } = useTrainingStore(); // Anwesenheitsliste aus dem Kontext abrufen
  const { getTrainingVotesValues, getTraining, getAdminisAbsent, getIfUserVoted } = useTrainingStore();

  useEffect(() => {
    auth().then(isAuth => {
      if (!isAuth) {
        handleLogout()
      }
    });
  }, [navigate]);

  const handleLogout = () => {
    // Alle Daten aus localStorage entfernen und den Login-Status zurücksetzen
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('role');
    localStorage.removeItem('token');
    localStorage.removeItem('userId'); // Optional, falls du die User-ID im LocalStorage speicherst

    // Benutzer zum Login weiterleiten
    navigate("/login");
  };



  useEffect(() => {
    // Benutzername und Rolle aus localStorage abrufen
    const name = localStorage.getItem('username');
    const userRole = localStorage.getItem('role');
    setUsername(name || "");
    setRole(userRole || "");

    //methode beim start aufrufen
    getTraining();
    getAdminisAbsent();
    getIfUserVoted(name);


    getTrainingVotesValues();
    const interval = setInterval(async () => {
      try {
        getTraining();
        getTrainingVotesValues();
        getAdminisAbsent();
      } catch (error) {
        console.error("Fehler beim Abrufen der Anwesenheitsliste:", error);
      }
    }, 30000); // polls every 30 seconds

    return () => clearInterval(interval);
  }, []);

  const handleChangeOne = () => {
    setCheckedOne(!checkboxOne);
    if (!checkboxOne) {
      setCheckedTwo(false); // Setze die zweite Checkbox zurück
    }
  };

  const handleChangeTwo = () => {
    setCheckedTwo(!checkboxTwo);
    if (!checkboxTwo) {
      setCheckedOne(false); // Setze die erste Checkbox zurück
    }
  };



  // Speichern der Anwesenheit
  const handleSave = async () => {
    if (!username) {
      alert("Fehler: Benutzername nicht gesetzt. Bitte melden Sie sich an.");
      return;
    }

    const vote = checkboxOne ? 1 : checkboxTwo ? 0 : null;
    if (vote != null) {
      try {
        await trainingVote({ username, vote });
        getTrainingVotesValues(); // Aktualisiere die Anwesenheitsliste
        getAdminisAbsent(); // Aktualisiere den Status des Trainings
        getIfUserVoted(username);
      } catch (error) {
        alert(`Fehler beim Speichern des Anwesenheits-Status: ${error.message}`);
      }
    } else {
      alert("Bitte wähle eine Option aus.");
    }
    //this.getAttendanceList();
  };

  if (isTrainingCanceled && role !== "ADMIN") {
    return <TrainingCanceled />;
  }

  const formatDateGerman = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }) + ' Uhr';
  };

  return (
    <>
      <div>
        <h2>Home</h2>
        <div className="info-box">
          <h3>Infomationen:</h3>
          <p><strong>🏋️‍♀️ Trainingstag:</strong> Jeden Mittwoch</p>
          <p><strong>🕒 Uhrzeit:</strong> 16:30 – 17:45 Uhr</p>
          <p><strong>📍 Ort:</strong> <a href={googleMapsUrl} target="_blank" rel="noopener noreferrer" className="link-black">{adresse}</a></p>
          <p><strong>🗳️ Abstimmung möglich bis:</strong> {formatDateGerman(trainingDeadline)}</p>
          <p><strong>👥 Hinweis:</strong> Das Training findet nur bei mindestens 3 Teilnehmern statt.</p>
        </div>

        <div className="training-message">
          <h3>Im nächsten Taining machen wir:</h3>
          <p>{trainingText || "Steht noch nicht fest"}</p>
        </div>
      </div>
      <div>
        <div className="attandance-vote">
          <h3>Nimmst Du teil? Bitte abstimmen</h3>
          <div className="checkbox-container">
            <input
              type="checkbox"
              checked={checkboxOne}
              onChange={handleChangeOne}
            />
            <label>Ich nehme teil</label>
            <i className="fas fa-user"
              style={{
                color: 'green',
                marginTop: '-10px',
                marginLeft: '11px'
              }}></i>
            <p style={{
              marginTop: '5px',
              marginLeft: '4px'
            }}>{anwesend}</p>
          </div>
          <div className="checkbox-container">
            <input
              type="checkbox"
              checked={checkboxTwo}
              onChange={handleChangeTwo}
            />
            <label>Ich nehme nicht teil</label>
            <i className="fas fa-user"
              style={{
                color: 'red',
                marginTop: '-10px',
                marginLeft: '11px'
              }}></i>
            <p style={{
              marginTop: '5px',
              marginLeft: '4px'
            }}>{abwesend}</p>
          </div>

          <div>
            <button onClick={handleSave}>Anwesenheit speichern</button>
          </div>
          <div>
          </div>
        </div>
        {/* Admin-Bereich nach rechts verschieben */}
        <div className="admin-section">
          {role === "ADMIN" && <Admin />} {/* Admin-Bereich anzeigen, falls Rolle ADMIN ist */}
        </div>

      </div>

    </>
  );
};

export default Home;
